<script>
    import { getAuth, signOut } from "firebase/auth";

    function signout () {
        const auth = getAuth();
            signOut(auth).then(() => {
            // Sign-out successful.
            }).catch((error) => {
            alert("Fehler bei der Abmeldung aufgetreten. Bitte versuche es gleich erneut.")
        });
    }
</script>

<button title="Abmelden" on:click={signout}>Abmelden</button>

<style>
    button {
        color: #666;
        background-color: #F0F0F0;
        border: transparent;
        border-radius: 0.5rem;
        padding: 0.4rem 1rem;
        margin: 0;
    }
</style>